import { DEFAULT_NODE_WIDTH } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const BLOCK_WIDTH = DEFAULT_NODE_WIDTH - sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * 2

export const Wrapper = {
  ...sharedStyles.systemBlock,
  width: `${BLOCK_WIDTH}px`,
  padding: 0,
  flexShrink: 0,
  marginRight: 48,
}

export const Content = {
  ...sharedStyles.column,
  position: 'relative',
  padding: sharedStyles.messengerBlock.padding,
} as const

export const Title = {
  ...sharedStyles.subheading,
  ...sharedStyles.textBlack,
}

export const Subtitle = {
  ...sharedStyles.text,
  ...sharedStyles.textSecondary,
}

export const Image = {
  borderRadius: '20px 20px 0 0',
}
